const TECH = [
  { name: "Agentic AI",                 group: "ai"    },
  { name: "UiPath Enterprise Automation", group: "rpa" },
  { name: "Multi-Agent Systems",        group: "ai"    },
  { name: "Generative AI",              group: "ai"    },
  { name: "WhatsApp AI Agents",         group: "ai"    },
  { name: "SAP Integration",            group: "ent"   },
  { name: "ERP Automation",             group: "ent"   },
  { name: "Process Mining",             group: "rpa"   },
  { name: "Intelligent Document Processing", group: "ai" },
  { name: "AI Decision Engines",        group: "ai"    },
  { name: "API Integrations",           group: "ent"   },
  { name: "Cloud-ready Automation",     group: "ent"   },
];

const TechExpertise = () => (
  <section id="tech" className="section bg-white" data-bg="white" data-testid="tech-section">
    <div className="section-inner">
      <div className="reveal">
        <span className="eyebrow">Our technology expertise</span>
        <h2 className="section-h2">
          Built on the same stack used by<br />
          <span className="serif">Fortune 500 enterprises</span>.
        </h2>
        <p className="section-sub">
          Aria combines best-in-class enterprise automation platforms with the
          latest in agentic and generative AI — engineered for production, not demos.
        </p>
      </div>

      <div className="tech-grid reveal">
        {TECH.map((t) => (
          <div key={t.name} className={`tech-pill tech-pill-${t.group}`} data-testid={`tech-${t.name}`}>
            <span className="tech-dot" />
            {t.name}
          </div>
        ))}
      </div>

      <div className="tech-legend reveal">
        <div className="tech-legend-item"><span className="tech-dot tech-pill-ai" /> Agentic & Generative AI</div>
        <div className="tech-legend-item"><span className="tech-dot tech-pill-rpa" /> RPA & Process Automation</div>
        <div className="tech-legend-item"><span className="tech-dot tech-pill-ent" /> Enterprise Integration</div>
      </div>
    </div>
  </section>
);

export default TechExpertise;
